export const scrubDataId = (dataId: string): string => {
    return dataId
        .toLowerCase()
        .replaceAll(' ', '-') // remove blank spaces
        .replaceAll(/--+/g, '-'); // remove multiple dashes
};
